import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  // Detect basename from current path (for WordPress integration)
  const basename = window.location.pathname.replace(/\/$/, '');
  
  return (
    <div className="App">
      <BrowserRouter basename={basename || '/'}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
